import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnLoader from "../toolbox/CgnLoader";
import ContentTop from "../root/ContentTop";
import CgnBadge from "../toolbox/CgnBadge";
import CgnAlert from "../toolbox/CgnAlert";
import CgnDatatable from "../toolbox/CgnDatatable";
import CgnMessage from "../toolbox/CgnMessage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";
import CgnButtonDropdown from "../toolbox/CgnButtonDropdown";
class CargoTrackingList extends Component {
  state = {
    pageTitle: "Kargo Takip Listele",
    pageAddLink: "kargo-takip-ekle",
    pageUpdateLink: "kargo-takip-guncelle",
    pageDetailLink: "kargo-takip-detay",
    pageListLink: "kargo-takip-listele",
    breadcrumb: [{ text: "Kargo Takip", link: "#" }],
    isLoading: false,
    isDeleted: false,
    status: false,
    data: [],
    name: "",
    guid: "",
    alertErrorMessage: "",
  };
  async componentDidMount() {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    axios
      .get(URL + "/cargotracking/getlist", config)
      .then((response) => {
        this.setState({
          data: response.data,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }
  handleDelete = (guid) => {
    confirmAlert({
      title: CgnMessage.deleteQuestionTitle,
      message: CgnMessage.deleteQuestionMessage,
      buttons: [
        {
          label: CgnMessage.deleteQuestionYes,
          onClick: () => this.deleteItem(guid),
        },
        {
          label: CgnMessage.deleteQuestionNo,
        },
      ],
    });
  };
  async deleteItem(guid) {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const URLParam = "/cargotracking/delete";
    const obj = {
      guid,
    };
    axios
      .post(URL + URLParam, obj, config)
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }
  thStyle = {
    width: "125px",
  };

  thStyle2 = {
    width: "95px",
  };

  tdStyle = {
    width: "150px",
  };
  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row className="CargoTrackingList" id="list">
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title={CgnMessage.alertErrorTitle}
                  text={this.state.alertErrorMessage}
                />
              )}
              <CgnDatatable
                data={this.state.data}
                title={this.state.pageTitle}
                columns={[
                  {
                    name: "Kargo Takip Bilgileri",
                    sortable: false,
                    cell: (row) => {
                      return (
                        <Table className="table table-responsive ">
                          <tbody>
                            <tr>
                              <th style={this.thStyle}>Tarih</th>
                              <td style={this.tdStyle}>{row.arrivedDate}</td>
                              <th style={this.thStyle2}>Kargo Türü</th>
                              <td>{row.shippingTypeName}</td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Kargo Firması</th>
                              <td style={this.tdStyle}>{row.shippingCompaniesName}</td>
                              <th style={this.thStyle2}>Müşteri</th>
                              <td>{row.customerName}</td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Ekleyen Kullanıcı</th>
                              <td colSpan={4}>{row.createdBy}</td>
                            </tr>
                          </tbody>
                        </Table>
                      );
                    },
                  },
                  {
                    name: "Müşteri",
                    selector: "isCustomerInfo",
                    width: "125px",
                    padding: "0px",
                    sortable: false,
                    cell: (row) => {
                      if (row.isCustomerInfo) {
                        return <CgnBadge color="success" text="Evet" className="w-100" />;
                      } else {
                        return <CgnBadge color="danger" text="Hayır" className="w-100" />;
                      } 
                    },
                  },
                  {
                    name: "Tarama",
                    selector: "isScanner",
                    width: "125px",
                    padding: "0px",
                    sortable: false,
                    cell: (row) => {
                      if (row.isScanner) {
                        return <CgnBadge color="success" text="Evet" className="w-100" />;
                      } else {
                        return <CgnBadge color="danger" text="Hayır" className="w-100" />;
                      } 
                    },
                  },
                  {
                    name: "Whatsapp",
                    selector: "isWhatsapp",
                    width: "125px",
                    padding: "0px",
                    sortable: false,
                    cell: (row) => {
                      if (row.isWhatsapp) {
                        return <CgnBadge color="success" text="Evet" className="w-100" />;
                      } else {
                        return <CgnBadge color="danger" text="Hayır" className="w-100" />;
                      } 
                    },
                  },
                  {
                    name: "Durumu",
                    selector: "status",
                    width: "125px",
                    padding: "0px",
                    sortable: false,
                    cell: (row) => {
                      if (row.status === 1) {
                        return <CgnBadge color="danger" text="Bekliyor" className="w-100" />;
                      } else if (row.status === 2) {
                        return <CgnBadge color="warning" text="İşlemde" className="w-100" />;
                      } else if (row.status === 3) {
                        return <CgnBadge color="success" text="Tamamlandı" className="w-100" />;
                      } else if (row.status === 4) {
                        return <CgnBadge color="primary" text="Teslim Edildi" className="w-100" />;
                      } else if (row.status === 5) {
                        return <CgnBadge color="secondary" text="İptal Edildi" className="w-100" />;
                      } else if (row.status === 6) {
                        return <CgnBadge color="dark" text="İade Edildi" className="w-100" />;
                      }
                    },
                  },
                  {
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                    cell: (row, cell) => (
                      <CgnButtonDropdown
                        label={"Yönet"}
                        className="mr-0"
                        color="primary"
                        items={[
                          {
                            text: CgnMessage.updateButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageUpdateLink}/${row.guid}`,
                          },
                          {
                            text: CgnMessage.detailButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageDetailLink}/${row.guid}`,
                          },
                          {
                            text: CgnMessage.deleteButton,
                            className: "dropDownBtn",
                            onClick: () => this.handleDelete(row.guid),
                          },
                        ]}
                      />
                    ),
                  },
                ]}
                loading={this.state.isLoading}
              />
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}
export default CargoTrackingList;
